// The copy of an invoice anyone with its link can read, at
// publicInvoices/{id}, drawn by public/invoice.html. Field for field what
// the phone app publishes (public_invoice.dart): only what the PDF shows,
// with the figures already worked out so the page does no maths.

import { type Business, businessToJson } from '@/core/business';
import { type Invoice, invoiceToJson, itemAmount, currencyOfInvoice, totalsOf } from '@/core/invoice';

export function publicInvoiceJson(args: { id: string; ownerUid: string; invoice: Invoice; business: Business; isPro: boolean }) {
  const { invoice, business } = args;
  const shown: Invoice = {
    ...invoice,
    clientId: null,
    // Payment notes stay private.
    payments: invoice.payments.map((p) => ({ ...p, note: '' })),
    // A page exists because the invoice was shared, so clients never see a draft.
    sentAt: invoice.sentAt ?? invoice.updatedAt,
    publicLinkId: args.id,
  };
  const currency = currencyOfInvoice(invoice);
  const t = totalsOf(shown);
  return {
    id: args.id,
    ownerUid: args.ownerUid,
    invoice: invoiceToJson(shown),
    business: businessToJson({ ...business, nextInvoiceNumber: 1, defaultNotes: '', invoicePrefix: '' }),
    isPro: args.isPro,
    amounts: {
      items: invoice.items.map((i) => itemAmount(i, currency).minor),
      subtotal: t.subtotal.minor,
      discount: t.discount.minor,
      tax: t.tax.minor,
      total: t.total.minor,
      paid: t.paid.minor,
      balance: t.balance.minor,
    },
  };
}
